/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 79a9a4f0c816
 */

import { assetsDerivedDestroy } from "../../funcs/assetsDerivedDestroy.js";
import { DerivedDestroyRequest$zodSchema } from "../../models/deriveddestroyrequest.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: DerivedDestroyRequest$zodSchema.describe(
    `The derived resource IDs to delete.`,
  ),
};

export const tool$assetsDerivedDestroy: ToolDefinition<typeof args> = {
  name: "delete-derived-assets",
  description: `Delete derived resources

Deletes derived resources by derived resource ID`,
  scopes: ["librarian"],
  annotations: {
    "title": "Delete Derived Assets",
    "destructiveHint": true,
    "idempotentHint": true,
    "openWorldHint": false,
    "readOnlyHint": false,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await assetsDerivedDestroy(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
